import React from "react";
import { Lightbox } from "react-modal-image";

import { withStyles } from "@material-ui/styles";
import { styles } from "./fileManager/styles";

class ModalImage extends React.Component {
  render() {
    const { handleClose, image } = this.props;
    return (
      <div>
        <Lightbox
          medium={image.url}
          small={image.thumbnail}
          large={image.download}
          alt={image.name}
          onClose={handleClose}
        />
      </div>
    );
  }
}
export default withStyles(styles)(ModalImage);
